const ZOOM_IN_KEY_CODE = 'ArrowUp';
const ZOOM_OUT_KEY_CODE = 'ArrowDown';
const ZOOM_RESET_KEY_CODE = (key: string) => key === 'R' || key === 'r';
const PAN_KEY_CODE = (key: string) => key === 'P' || key === 'p';
const ZOOM_MODE_KEY_CODE = (key: string) => key === 'Z' || key === 'z';
const EXPLORE_MODE_KEY_CODE = (key: string) => key === 'E' || key === 'e';

/** returns a boolean determining if it is a zoomIn keyboard event
 * @param event - A keyboard event param.
 */
export function isZoomIn({ key, metaKey, ctrlKey }: KeyboardEvent) {
  return key === ZOOM_IN_KEY_CODE && (metaKey || ctrlKey);
}

/** returns a boolean determining if it is a zoomIn wheel event
 * @param event - A wheel event param.
 */
export function isZoomInWheel({ deltaY, metaKey, ctrlKey }: WheelEvent) {
  return deltaY < 0 && (ctrlKey || metaKey);
}

/** returns a boolean determining if it is a zoomOut keyboard event
 * @param event - A keyboard event param.
 */
export function isZoomOut({ key, metaKey, ctrlKey }: KeyboardEvent) {
  return key === ZOOM_OUT_KEY_CODE && (metaKey || ctrlKey);
}

/** returns a boolean determining if it is a zoomOut wheel event
 * @param event - A wheel event param.
 */
export function isZoomOutWheel({ deltaY, metaKey, ctrlKey }: WheelEvent) {
  return deltaY > 0 && (ctrlKey || metaKey);
}

/** returns a boolean determining if it is a zoomX keyboard event
 * @param event - A keyboard event param.
 */
export function isZoomX({ key }: KeyboardEvent) {
  return ZOOM_MODE_KEY_CODE(key);
}

/** returns a boolean determining if key for Explore mode is pressed
 * @param event - A keyboard event param.
 */
export function isExplore({ key }: KeyboardEvent) {
  return EXPLORE_MODE_KEY_CODE(key);
}

/** returns a boolean determining if it is a reset keyboard event
 * @param event - A keyboard event param.
 */
export function isReset({ key }: KeyboardEvent) {
  return ZOOM_RESET_KEY_CODE(key);
}

/** returns a boolean determining if it is a pan keyboard event
 * @param event - A keyboard event param.
 */
export function isPan({ key }: KeyboardEvent) {
  return PAN_KEY_CODE(key);
}
